import { getCookie, setCookie } from './cookie'

export const getAnonymousIdentity = (): string => {
  const existing = getCookie('identity')
  if (existing) return existing
  const identity = crypto.randomUUID()
  setCookie('identity', identity, 60 * 60 * 24 * 365)
  return identity
}
